import { defineStore } from "pinia"
import { ref } from 'vue'

export const useLicenseInputStore = defineStore('licenseInput', () => {
  const display = ref(false)
  const fromLogin = ref<boolean | undefined>(false)

  const show = (from_login?: boolean) => {
    fromLogin.value = from_login
    display.value = true
  }
  const hide = () => {
    display.value = false
    fromLogin.value = undefined
  }

  return {
    display,
    fromLogin,
    show,
    hide,
  }
})